import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import download from 'downloadjs'
import { toJpeg } from 'html-to-image'
import { Cover, Sidebar } from 'components'
import { FormProvider, useForm } from 'contexts'
import { trackGoal } from 'utils/fathom'

const App = () => {
  const { t } = useTranslation()
  const coverRef = useRef()
  const { formData } = useForm()

  const handleDownload = () => {
    toJpeg(coverRef.current, {
      quality: 0.9,
    }).then(dataUrl => {
      trackGoal('ENVON5CL')
      const title = formData.title || t('cover.filename')

      download(
        dataUrl,
        `${title.toLowerCase().replace(/\s/g, '_')}.jpeg`,
        'image/jpeg',
      )
    })
  }

  return (
    <>
      <Sidebar onDownload={handleDownload} />
      <Cover ref={coverRef} />
    </>
  )
}

export default () => (
  <FormProvider>
    <App />
  </FormProvider>
)
